// Real UTME subjects, not broad tracks — a tutor ticks the actual subjects
// they teach, which is what lets a learner's requested subject COMBINATION
// (e.g. Physics/Chemistry/Biology/Mathematics) be matched against a tutor
// who actually covers that combination, instead of both sides just saying
// "Science" and hoping it lines up.
export const JAMB_SUBJECTS = [
  "English Language",
  "Mathematics",
  "Physics",
  "Chemistry",
  "Biology",
  "Agricultural Science",
  "Economics",
  "Government",
  "Literature in English",
  "CRS/IRS",
  "History",
  "Geography",
  "Commerce",
  "Accounting",
  "Civic Education",
];

// WAEC/NECO stays track-level (not individual subjects) — matches the
// standard Science/Arts/Commercial streaming used across Nigerian secondary
// schools, not a UTME-style subject combination.
export const WAEC_TRACKS = ["Science", "Arts", "Commercial"];

export const ADULT_EDUCATION_SKILLS = [
  "Reading",
  "Writing",
  "Spelling",
  "Public Speaking",
];

export const LEARNER_LEVELS = ["Beginner", "Intermediate", "Advanced"];

export const PROGRAM_CATEGORIES = [
  {
    group: "JAMB",
    items: JAMB_SUBJECTS,
  },
  {
    group: "WAEC/NECO",
    items: WAEC_TRACKS,
  },
  {
    group: "Adult Education",
    items: ADULT_EDUCATION_SKILLS,
  },
  {
    group: "Basic & Secondary Education",
    items: [
      "JSS 3 Exam Prep",
      "WAEC/NECO Prep – Science",
      "WAEC/NECO Prep – Arts",
      "WAEC/NECO Prep – Commercial",
    ],
  },
  {
    group: "Adult & Foundational Education",
    items: ["Adult Literacy (Reading, Writing, Spelling, Speaking)"],
  },
  {
    group: "University Entrance & Admission Prep",
    items: [
      "JAMB Prep – Science",
      "JAMB Prep – Arts",
      "JAMB Prep – Commercial",
      "Post-UTME Prep – UNILORIN",
      "Post-UTME Prep – LASU",
      "Post-UTME Prep – UNILAG",
      "Post-UTME Prep – FUOYE",
      "Post-UTME Prep – UNIZIK",
      "Post-UTME Prep – UNN",
      "Post-UTME Prep – UI",
      "Post-UTME Prep – UNIBEN",
      "Post-UTME Prep – OAU",
      "Post-UTME Prep – UNIPORT",
      "Post-UTME Prep – FULAFIA",
    ],
  },
  {
    group: "International Exams & Study Abroad",
    items: [
      "IELTS (Academic & General)",
      "TOEFL",
      "PTE Academic",
      "GRE / GMAT / SAT Preparation",
      "Cambridge IGCSE & A-Level Preparation",
    ],
  },
  {
    group: "Professional Certification & Career Exams",
    items: [
      "ICAN Exam Prep",
      "ANAN Exam Prep",
      "ACCA Exam Prep",
      "PMP Exam Prep",
      "CISA Exam Prep",
      "CIPM Exam Prep",
      "CIBN Exam Prep",
      "CCNA Exam Prep",
      "CFA Exam Prep",
      "COREN Exam Prep",
    ],
  },
  {
    group: "Language Learning",
    items: [
      "French Language",
      "Mandarin (Chinese)",
      "Arabic Language",
      "German Language",
      "Yoruba Language",
      "Igbo Language",
      "Hausa Language",
    ],
  },
  {
    group: "Digital & Technology Skills",
    items: [
      "Basic Computer Training",
      "Web & App Development",
      "Data Analysis",
      "Graphic Design",
      "Digital Marketing",
    ],
  },
  {
    group: "Business, Finance & Workplace Skills",
    items: [
      "Financial Literacy & Personal Finance",
      "Sales & Customer Service",
      "Grant Writing & Fundraising",
      "Public Speaking Classes",
    ],
  },
  {
    group: "Technical, Vocational & Trade Skills (TVET)",
    items: [
      "Solar PV Installation & Maintenance",
      "Electrical Installation & Maintenance",
      "Plumbing & Pipefitting",
      "Welding & Fabrication / Metalwork",
      "Carpentry & Joinery",
      "Auto Mechanics & Vehicle Maintenance",
      "HVAC Installation & Maintenance",
    ],
  },
  {
    group: "Creative, Fashion & Beauty Skills",
    items: [
      "Fashion Design & Tailoring",
      "Hairdressing & Cosmetology",
      "Barbing",
      "Photography",
      "Videography",
    ],
  },
  {
    group: "Hospitality, Food & Lifestyle Skills",
    items: ["Catering & Baking", "Hospitality Services"],
  },
  {
    group: "Health, Safety & Care Services",
    items: ["Caregiving", "First Aid Training", "Occupational Health & Safety"],
  },
  {
    group: "Arts, Music & Performance",
    items: ["Music (Voice & Instruments)", "Dance Classes"],
  },
];

// Optional: flat list of all category names (useful for validation / searching)
export const ALL_COURSE_CATEGORIES = PROGRAM_CATEGORIES.flatMap(
  (group) => group.items,
);

// TutorsLinks' core focus areas — get visual priority (listed first,
// highlighted on the homepage) in category pickers, but every other group
// below is fully selectable too, not restricted to just these three.
export const CORE_PROGRAM_CATEGORIES = ["JAMB", "WAEC/NECO", "Adult Education"];

export const SELECTABLE_PROGRAM_CATEGORIES = [
  ...CORE_PROGRAM_CATEGORIES,
  ...PROGRAM_CATEGORIES.map((g) => g.group).filter(
    (g) => !CORE_PROGRAM_CATEGORIES.includes(g),
  ),
];

// Optional: if you want to show them as value/label objects for selects
export const COURSE_CATEGORY_OPTIONS = ALL_COURSE_CATEGORIES.map((name) => ({
  value: name,
  label: name,
}));
